import IRecaptchaService from './IRecaptchaService';
import { RefObject } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

export default class RecaptchaService implements IRecaptchaService {
  private readonly reference: RefObject<ReCAPTCHA>;

  public constructor(reference: RefObject<ReCAPTCHA>) {
    this.reference = reference;
  }
  trigger(): void {
    if (!this.reference.current) {
      throw Error('Reference does not have an element associated with it.');
    }
    this.reference.current.execute();
  }

  async triggerAsync(): Promise<string | null> {
    if (!this.reference.current) {
      throw Error('Reference does not have an element associated with it.');
    }
    //if user goes back to bank select and chooses another bank too quickly, recaptcha breaks the entire interaction. so reset it.
    this.reference.current.reset();
    return await this.reference.current.executeAsync();
  }

  reset(): void {
    if (!this.reference.current) {
      throw Error('Reference does not have an element associated with it.');
    }

    this.reference.current.reset();
  }
}
